export default __webpack_public_path__ + "static/media/Accreditation-5.df01731c.png";